import React from 'react'
import TransactionLogDetailContainer from 'containers/panel/admin/transaction-log-detail-container'

const TransactionLogDetailPage = () => {
  return (
    <TransactionLogDetailContainer />
  )
}

export default TransactionLogDetailPage